<template>
  <div class="header">
    <div class="ad" v-show="adShow && topAd">
      <div
        class="ad-img"
        :style="{ backgroundImage: `url(${topAd.image})` }"
        @click="goAd(topAd)"
        v-if="topAd.image"
      ></div>
      <div class="box-right" v-if="topAd.hf_isshow === '1'">
        <i class="iconfont close" @click="adShow = false">&#xe601;</i>
      </div>
    </div>
    <div
      class="top"
      :class="{
        shouyeStyle: ['/', '/pc/'].includes($route.path),
      }"
      ref="shouyeStyle"
    >
      <div class="top-center">
        <div class="top-left">
          <span class="top-left-logo"></span>
          <div class="top-nav" :class="{ 'login-nav': !noLogin }">
            <router-link to="/" class="top-words">{{
              $t("header.home")
            }}</router-link>
            <router-link to="/live" class="top-words liveLiving">{{
              $t("header.anchor")
            }}</router-link>
            <router-link to="/competition" class="top-words">{{
              $t("header.schedule")
            }}</router-link>
            <router-link to="/anchor" class="top-words">{{
              $t("header.anchor_recruitment")
            }}</router-link>
            <router-link to="/advisory" class="top-words">{{
              $t("header.news")
            }}</router-link>
            <router-link to="/subscription" class="top-words">{{
              $t("header.subscribe")
            }}</router-link>
            <router-link to="/download" class="top-words">{{
              $t("header.download")
            }}</router-link>
            <router-link to="/tutorial" class="top-words">{{
              $t("header.主播教程")
            }}</router-link>
          </div>
        </div>
        <div class="top-right">
          <!-- <div class="lang-switch">
            <el-dropdown @command="changeLang" trigger="click">
              <span class="lang-dropdown-btn">
                <i class="iconfont" style="font-size: 1.2rem">&#xe6b7;</i>
                {{ currentLangLabel }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="lang-dropdown-menu">
                <el-dropdown-item
                  v-for="lang in langs"
                  :key="lang.value"
                  :command="lang.value"
                  :disabled="lang.value === currentLang"
                >
                  {{ lang.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
          <!-- <div class="top-sqzb" @click="showTip">
            <i class="iconfont icon-sqzb"></i> {{ $t("header.apply_anchor") }}
          </div> -->
          <!-- <div class="top-sqzb" @click="showTip">
            <i class="iconfont icon-sqzb"></i> {{ $t("header.apply_anchor") }}
          </div> -->
          <div class="login-register" v-show="noLogin">
            <div class="top-login" @click="openLoginDialog">
              <i class="iconfont icon-login">&#xe659;</i>
              {{ $t("header.login") }}
            </div>
            <div class="top-L">|</div>
            <div @click="openRegister" class="top-register">
              {{ $t("header.register") }}
            </div>
          </div>
          <div class="done-login" v-show="!noLogin">
            <div class="login-register alredy-login">
              <div
                class="userad"
                :style="`background-image:url(${$store.state.userInfo.avatar_thumb})`"
              ></div>
              <div class="user-name">
                {{ $store.state.userInfo.user_nicename || "" }}
              </div>
              <i class="iconfont down">&#xe66d;</i>
            </div>
            <div class="user-center">
              <router-link to="/personal" tag="div" class="user-list">
                {{ $t("header.personal_center") }}
              </router-link>
              <router-link
                to="/"
                tag="div"
                class="user-list"
                @click.native="signOut"
              >
                {{ $t("header.logout") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login
      v-if="authDialogsLoaded"
      ref="login"
      @goLigin="openRegister"
      @loginSuccess="loginSuccess"
    ></login>
    <register
      v-if="authDialogsLoaded"
      ref="register"
      @loginShow="openLoginDialog"
      @loginSuccess="loginSuccess"
    ></register>
    <find-password v-if="authDialogsLoaded"></find-password>
  </div>
</template>

<script>
import img1 from "./../assets/img/logo.png";
import img2 from "./../assets/img/logo-home.png";
import { apiClickAd } from "../http";

const loadLogin = () =>
  import(/* webpackChunkName: "auth-dialogs" */ "./login").then(
    (module) => module.default || module
  );
const loadRegister = () =>
  import(/* webpackChunkName: "auth-dialogs" */ "./register").then(
    (module) => module.default || module
  );
const loadFindPassword = () =>
  import(/* webpackChunkName: "auth-dialogs" */ "./findPassword").then(
    (module) => module.default || module
  );
const loadAuthDialogs = () =>
  Promise.all([loadLogin(), loadRegister(), loadFindPassword()]);

export default {
  name: "pageheader",
  components: {
    login: loadLogin,
    register: loadRegister,
    findPassword: loadFindPassword,
  },
  computed: {
    homeConfig() {
      return this.$store.state.config;
    },
  },
  data() {
    return {
      adShow: true,
      authDialogsLoaded: false,
      noLogin: true,
      readSearch: true,
      shouyeLogo: "",
      topAd: {
        hf_isshow: "0",
        image: "",
      },
      searchVal: "",
      langs: [
        // { value: "zh", label: "简体中文" },
        // { value: "zhTW", label: "繁體中文" },
        // { value: "en", label: "English" },
        { value: "vi", label: "Tiếng Việt" },

        // 未来可扩展更多语言
      ],
      currentLang: "vi",
    };
  },
  computed: {
    homeConfig() {
      return this.$store.state.config;
    },
    currentLangLabel() {
      const lang = this.langs.find((l) => l.value === this.currentLang);
      return lang ? lang.label : "";
    },
  },
  watch: {
    // 保证切换路由时语言不丢失
    currentLang(val) {
      this.$i18n.locale = val;
      localStorage.setItem("lang", val);
    },
  },
  methods: {
    changeLang(lang) {
      this.currentLang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },
    showTip() {
      // this.$EventBus.$emit("hide",{type:'success',msg:'敬请期待！'});
      let url = this.homeConfig.service_url;
      window.open(url, "", "channelmode=yes,width=820,height=600");
    },
    handlerInputClick() {
      this.readSearch = false;
    },
    search() {
      if (this.$route.name === "live") {
        this.$EventBus.$emit("searchFunc", this.searchVal);
      } else {
        this.$router.push({ name: "live", params: { val: this.searchVal } });
      }
      this.searchVal = "";
    },

    shouyeSpeSty() {
      //首页特殊样式
      // this.$refs.shouyeStyle.classList.add('shouyeStyle');
      this.shouyeLogo = img1;
    },
    cancelShouye() {
      //取消首页特殊样式
      // this.$refs.shouyeStyle.classList.remove('shouyeStyle');
      this.shouyeLogo = img2;
    },
    goLiveDetails() {
      //从首页跳转至直播详情页
      // this.$nextTick(() => {
      //   document
      //     .getElementsByClassName("liveLiving")[0]
      //     .classList.add("router-link-exact-active");
      // });
    },
    goOtherP() {
      document
        .getElementsByClassName("liveLiving")[0]
        .classList.remove("router-link-exact-active");
    },
    signOut() {
      //退出登录
      this.$axios
        .post("/", {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          service: "PCLogin.Logout",
        })
        .then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            this.closeLiveBtn();
            localStorage.removeItem("uid");
            localStorage.removeItem("token");
            this.$store.commit("getUserInfo", {});
            this.noLogin = true;
          }
        });
    },
    ensureAuthDialogs() {
      this.authDialogsLoaded = true;
      return loadAuthDialogs().then(() => this.$nextTick());
    },
    openLoginDialog() {
      //点击登录
      this.ensureAuthDialogs().then(() => {
        this.$refs.login.open();
      });
    },
    openRegister() {
      //点击注册
      this.ensureAuthDialogs().then(() => {
        this.$refs.register.open();
      });
    },
    loginSuccess() {
      this.noLogin = false;
    },
    closeLiveBtn() {
      //关闭直播
      let stream = localStorage.getItem("stream");
      if (!stream) return;
      let arr = stream.split("?");
      this.$axios
        .post("/", {
          service: "PCLive.StopRoom",
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          stream: arr[0],
        })
        .then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            localStorage.removeItem("stream");
          }
        });
    },
    goAd(item) {
      this.clickAd(item);
      if (item.url) {
        window.open(item.url);
      }
    },
    clickAd(ad) {
      apiClickAd({ slide_items_id: ad.slide_id }).then((res) => {});
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.noLogin = false;
    }
    this.$EventBus.$on("loginOut", () => {
      this.noLogin = true;
    });
    this.$EventBus.$on("login", () => {
      this.openLoginDialog();
    });
    this.$EventBus.$on("loginShow", () => {
      this.openLoginDialog();
    });
    this.$EventBus.$on("set-top-ad", (ad) => {
      console.log(ad);
      this.topAd = ad;
    });
    this.$i18n.locale = this.currentLang;
  },
};
</script>
<style>
.header .el-input {
  width: 180px;
}
.header .el-input input {
  border-radius: 25px;
}
.header .el-input__suffix {
  display: flex;
  align-items: center;
  padding-right: 5px;
}
</style>

<style lang="scss" scoped>
.lang-switch {
  margin-right: 24px;
  display: flex;
  align-items: center;
  .lang-dropdown-btn {
    display: flex;
    align-items: center;
    background: #f8f8f8;
    border-radius: 20px;
    padding: 0 18px;
    height: 32px;
    font-size: 1.3rem;
    color: #333;
    cursor: pointer;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
    transition: border-color 0.2s;
    &:hover {
      border: 1px solid #f9ba07;
      background: #fffbe8;
      color: #ee8f01;
    }
    .el-icon-arrow-down {
      margin-left: 8px;
      font-size: 1.2rem;
    }
  }
}
.lang-dropdown-menu {
  min-width: 120px;
  .el-dropdown-menu__item {
    font-size: 1.2rem;
    padding: 8px 18px;
    border-radius: 8px;
    &:hover,
    &.selected {
      background: #fffbe8;
      color: #ee8f01;
    }
  }
}
.lang-select-popper {
  .el-select-dropdown__item {
    font-size: 1.2rem;
    padding: 8px 18px;
    border-radius: 8px;
    transition: background 0.2s;
    &:hover,
    &.selected {
      background: #fffbe8;
      color: #ee8f01;
    }
  }
}
.header {
  min-width: 120rem;
}
a {
  color: #2b2626;
}
.ad {
  width: 100%;
  color: #fff;
  position: relative;
  background: #000;
  cursor: pointer;
}
.ad img {
  width: 100%;
}
.top {
  min-width: 100%;
  background: #fff;
  font-size: 1.4rem;
  color: #2b2626;
  position: absolute;
}
.shouyeStyle {
  color: #fff;
  background: transparent;
  padding: 0.5rem 0;
}

.shouyeStyle:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: hsla(0, 0%, 100%, 0.08);
}
.top-center {
  width: 124rem;
  margin: 0 auto;
  height: 5.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
// .shouyeStyle a {
//   color: #fff;
// }
.top-left {
  display: flex;
  align-items: center;
}

.top-left-logo {
  display: inline-block;
  width: 12.8rem;
  height: 3.8rem;
  background-image: var(--img-logo);
  background-size: 100% 100%;
  transform: scale(1.3);
}
.shouyeStyle .top-left-logo {
  background-image: var(--images-logo);
}
.top-nav {
  display: flex;
  justify-content: space-around;
  margin-left: 2rem;
  // margin-right: 4rem;
  font-weight: bolder;
  font-size: 1.6rem;

  &.login-nav {
    margin-left: 2rem;
  }
}

.shouyeStyle a.router-link-exact-active {
  color: #fff;
  border-bottom: 0.24rem solid #fff;
}
a.router-link-exact-active {
  color: #333;
  border-bottom: 0.24rem solid #333;
}

.top-words {
  padding: 0.6rem 1.4rem;
  margin: 0 1rem;
  cursor: pointer;
  color: rgb(55, 122, 61);
}
.shouyeStyle .top-words:hover {
  color: #fff;
  border-bottom: 0.24rem solid #fff;
}
.top-words:hover {
  color: #333;
  border-bottom: 0.24rem solid #333;
}
.login-register {
  width: 17rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.top-login,
.top-register {
  cursor: pointer;
}
.top-sqzb {
  display: flex;
  align-items: center;
  margin-right: 10px;
  height: 54px;
  cursor: pointer;
}
.icon-sqzb {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACS0lEQVQ4T3WTT2gTQRTGv7d/AlokRlmSvr2I+IdCLoKoiB6EFtTqxX8HLyJFEUFFiuJB66EHFbTqQelN6EWIB1H0JF6kIGIREXMwepOZTSgETbeFbpJ5siUryRrnNjPf/Oab782jUqlkIzU8z1tl2/awbdtbRKQJ4HO5XJ7N5XImraU0gJlHAUwTUSgin+IDRLQLQN0YczoIgq/dkB4AM18EcAXAOa3160ToeR65rnsKwF0AR7TW75K9vwDP84YymcxsFEV7KpXKt2KxeAHAqIgsGmNmqtXq80KhcNiyrHuNRmNbGIaLK+6SJ/i+/1REvmutJ3zffwJgq4hMAVhDRDeNMbeDIJhm5ldE9EYp9TANUK1W6ySAn47jfFxYWNjYaDR+x6J8Pr/Ttu0XWusCM58BsF9rfTQNaLRaraLjOJsB3FJK7ejKwM1kMktRFK2Lq2NZ1nmt9Uga8N4YMykic5ZlVQBs11r/iEXMfIyIJpVSQ8x8GcAGrfWlHgAzxwnntNZjHdFVIpoRkSwRHQdwQin1lpnnjDF3qtXqsx5ANptdPzAwUAYwFpeQmXcDOAhgCUApduP7/jUROdRsNvfOz89LDyCeDA4OHujc+nh5efl+vV7/1Vn3AVwnouF2uz1aq9XiJ66Mfj9xE4AHAPYBUJ2fuFZEXoZhOJ5U5r+AZIOZV8fWReRLEAQ3ALTTfdDXQbeImeMQPwRB8Kjf4b6AfD7PjuOMi0jcpSNEVItdENGiUmoi7eSfDDzP81zXPQugp81jQBRFU0n6iaM/y0MlMLc7A7sAAAAASUVORK5CYII=);
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 5px;
}

.icon-login {
}
.box-right {
  width: 120rem;
  height: 100%;
  margin: 0 auto;
  top: 0;
  left: 50%;
  margin-left: -60rem;
  position: absolute;
}
.close {
  cursor: pointer;
  position: absolute;
  color: beige;
  right: 0;
  top: 40%;
  font-size: 1rem;
}
.userad {
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 50%;
  overflow: hidden;
  background-size: 100% 100%;
}
.shouyeStyle .user-name {
  color: #fff;
}
.user-name {
  color: #2c2727;
  font-weight: 500;
  font-size: 1.4rem;
  width: 7.1rem;
  height: 1.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.alredy-login {
  width: 14.6rem;
  cursor: pointer;
}
.down {
  font-size: 1.4rem;
  color: #abaaaa;
}
.done-login {
  position: relative;
  height: 100%;
}
.done-login:hover .user-center {
  display: block;
}
.user-center {
  display: none;
  position: absolute;
  top: 5.4rem;
  left: 0;
  width: 16.6rem;
  z-index: 1;
  background: #fff;
  text-align: center;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  cursor: pointer;
  z-index: 9;
  overflow: hidden;
}
.user-list {
  width: 16.6rem;
  height: 3.2rem;
  line-height: 3.2rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c2626;
}
.user-list:hover {
  background: #dff7f9;
}
.top-right {
  height: 100%;
  display: flex;
  align-items: center;
}
.ad-img {
  width: 120rem;
  height: 8rem;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto;
}
.downloadHead {
  background: linear-gradient(to right, #3e0a0a 20%, #77292d, #531010);
  .top-nav a,
  .login-register div {
    color: #fff;
  }
  .icon-login {
    font-size: 12px;
    padding: 4px;
    color: #d19f66;
    border-radius: 50%;
    border: 1px solid #d19f66;
  }
  .top-left-logo {
    background-image: var(--images-logo);
  }
}
.downloadHead .bywz,
.downloadHead .top-sqzb {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/base/header.vue